module.exports = __webpack_public_path__ + "static/moonamar-aceite-de-comino-negro-en-capsulas-halal-250-8217baf4eb733523ce50482966cfbdf5.png";